import { createContext, useContext } from 'react';

export const NotificationContext = createContext<(title: string) => void>(() => undefined);

export function useNotify() {
  return useContext(NotificationContext);
}
